
<ci-icon-button 
  class="header__close-button"
  type="standard" 
  name="close"
  (click)="handleCloseOnClick()"
></ci-icon-button>